var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('dv-loading',[_vm._v("加载中...")]):(_vm.list && _vm.list.length)?_c('dv-scroll-board',{staticClass:"plan-box",attrs:{"config":_vm.config}}):_c('div',{staticClass:"empty"},[_vm._v("暂无数据")])
}
var staticRenderFns = []

export { render, staticRenderFns }